import './App.css';
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './Components/Auth/Login';
import Signup from './Components/Auth/Signup';
import Overview from './Components/Main/Overview';
import Home from './Components/Main/Home';
import Transactions from './Components/Main/Transactions';
import QATicket from './Components/Main/QATicket';
// import Settings from './Components/Main/Settings';
import Payment from './Components/Main/Payment';
import Website from './Components/Main/Websites';
import Publishers from './Components/Main/Publishers';
import ProtectedRoute from './Components/Auth/ProtectedRoute';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './Components/Auth/AuthContext';
import WebAnalytics from './Components/Main/WebAnalytics';
import Adunits from './Components/Main/Adunits';
import AdsTxtConfiguration from './Components/Main/AdsTxtConfiguration';
import AdsCodeConfiguration from './Components/Main/AdsCodeConfiguration';
import AdminSettings from './Components/Main/AdminSettings';
import WebReports from './Components/Main/WebReports';
import AppAnalytics from './Components/Main/AppAnalytics';
import AppReports from './Components/Main/AppReports';
import AdminPaymentInfo from './Components/Main/AdminPaymentInfo';
import ForgotPassword from './Components/Auth/ForgotPassword';
import InvoicePage from './Components/Main/InvoicePage';

function App() {
  const appVersion = '1.0.8';

  useEffect(() => {
    const storedVersion = localStorage.getItem('appVersion');
    if (storedVersion !== appVersion) {
      localStorage.setItem('appVersion', appVersion);
      window.location.reload(true); // reload from server
    }
  }, []);
  return (
    <AuthProvider>
      <ToastContainer />
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />

          {/* Protected Routes */}
          <Route
            path="/overview"
            element={
              <ProtectedRoute >
                <Overview />
              </ProtectedRoute>
            }
          />
          <Route
            path="/home"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />
          <Route
            path="/webanalytics"
            element={
              <ProtectedRoute>
                <WebAnalytics />
              </ProtectedRoute>
            }
          />
          <Route
            path="/appanalytics"
            element={
              <ProtectedRoute>
                <AppAnalytics />
              </ProtectedRoute>
            }
          />
          <Route
            path="/adunits"
            element={
              <ProtectedRoute>
                <Adunits />
              </ProtectedRoute>
            }
          />
          <Route
            path="/transactions"
            element={
              <ProtectedRoute>
                <Transactions />
              </ProtectedRoute>
            }
          />
          <Route
            path="/qa-tickets"
            element={
              <ProtectedRoute>
                <QATicket />
              </ProtectedRoute>
            }
          />
          {/* <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            }
          /> */}
          <Route
            path="/payment"
            element={
              <ProtectedRoute>
                <Payment />
              </ProtectedRoute>
            }
          />
          <Route
            path="/invoice"
            element={
              <ProtectedRoute>
                <InvoicePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/website"
            element={
              <ProtectedRoute>
                <Website />
              </ProtectedRoute>
            }
          />
          <Route
            path="/AdsTxtConfiguration"
            element={
              <ProtectedRoute>
                <AdsTxtConfiguration />
              </ProtectedRoute>
            }
          />
          <Route
            path="/AdsCodeConfiguration"
            element={
              <ProtectedRoute>
                <AdsCodeConfiguration />
              </ProtectedRoute>
            }
          />



          {/* Admin-Only Route */}
          <Route
            path="/webreports"
            element={
              <ProtectedRoute>
                <WebReports />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/payment-info"
            element={
              <ProtectedRoute>
                <AdminPaymentInfo />
              </ProtectedRoute>
            }
          />
          <Route
            path="/appreports"
            element={
              <ProtectedRoute>
                <AppReports />
              </ProtectedRoute>
            }
          />
          <Route
            path="/publishers"
            element={
              <ProtectedRoute requiredRole="Admin">
                <Publishers />
              </ProtectedRoute>
            }
          />
          <Route
            path="/adminsetting"
            element={
              <ProtectedRoute requiredRole="Admin">
                <AdminSettings />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
